import { useFetchCollection } from './useFetchCollection'
import { setDefaultApiResponseWithMeta } from '../useInternalApi'

const all = () => {
  const { getAll } = useFetchCollection()

  return useAsyncState(getAll, setDefaultApiResponseWithMeta())
}

export const useQueryCollection = {
  all,
}
